import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { defineMessages, useIntl } from 'react-intl';

const qualityRangeBrushLabelMessages = defineMessages({
  label: {
    id: 'logger.reports.streamQuality.availability.rangeBrush.label',
    defaultMessage: 'Ajustar rango',
  },
  resetFullRange: {
    id: 'logger.reports.streamQuality.availability.rangeBrush.resetFullRange',
    defaultMessage: 'Volver al rango completo del informe',
  },
});

export type RangeBrushLabelColumnProps = {
  /** Column width (px); aligns with timeline left margin. */
  widthPx: number;
  /** When false, the visible window matches the full report domain. */
  canReset: boolean;
  /** Restores the visible range to the full report interval. */
  onReset: () => void;
};

/**
 * Left column for the overview brush: short hint plus an optional control to restore the full time range.
 */
export function RangeBrushLabelColumn({ widthPx, canReset, onReset }: RangeBrushLabelColumnProps) {
  const { formatMessage: $t } = useIntl();

  return (
    <Box
      sx={{
        width: widthPx,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'center',
        pr: 1,
      }}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        component="span"
        sx={{ alignSelf: 'stretch', textAlign: 'right' }}
      >
        {$t(qualityRangeBrushLabelMessages.label)}
      </Typography>
      <Tooltip title={$t(qualityRangeBrushLabelMessages.resetFullRange)}>
        <IconButton disabled={!canReset} size="small" onClick={onReset} sx={{ mt: 0.25, mr: -0.5 }}>
          <ZoomOutMapIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
